export const navigationDe = {
  "Navigation.overview": "Übersicht",
  "Navigation.account": "Mein Konto",
  "Navigation.general": "Allgemein",
  "Navigation.backToOverview": "Zurück zur Übersicht",
} as const;
export const navigationEn = {
  "Navigation.overview": "Overview",
  "Navigation.account": "My account",
  "Navigation.general": "General",
  "Navigation.backToOverview": "Back to overview",
} as const;
export const navigationRu = {
  "Navigation.overview": "Обзор",
  "Navigation.account": "Моя учётная запись",
  "Navigation.general": "Общие",
  "Navigation.backToOverview": "Назад к обзору",
} as const;
